import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { Preferences } from '@capacitor/preferences';
import { ModalController } from '@ionic/angular';
import { ChatPage } from 'src/app/pages/chat/chat.page';
import { EmailValidationPage } from 'src/app/pages/email-validation/email-validation.page';
import { LoginPage } from 'src/app/pages/login/login.page';
import { MatchService } from 'src/app/services/match.service';
import { Swiper } from 'swiper';

@Component({
  selector: 'app-matches-carousel',
  templateUrl: './matches-carousel.component.html',
  styleUrls: ['./matches-carousel.component.scss'],
  providers: [MatchService]
})
export class MatchesCarouselComponent  implements OnInit {

  public swiper!: Swiper;
  public userData : any;
  public haveMatches : boolean = false;

  @Output() refreshListEvent = new EventEmitter<void>(); // Initialize Emitter
  
  constructor(
    public matchService: MatchService,
    public modalCtrl: ModalController,
    private router: Router,
  ) { }

  onImageError(event: Event) {
    const imgElement = event.target as HTMLImageElement;
    imgElement.src = "assets/imgs/no-picture.png"; // Caminho da imagem de fallback
  }

  ngOnInit() {
    this.swiper = new Swiper('.swiper', {
      speed: 400,
      slidesPerView: "auto",
      spaceBetween: 6, // Gap
      slidesOffsetBefore: 16, // Offset before the first slide
      observeParents: true, // Check father component to changes
    });

    Preferences.get({ key: 'USER_DATA' }).then((val:any) => {
      val = val.value ? JSON.parse(val.value) : null;

      if(val === null){
        this.modalCtrl.create({component: LoginPage}).then((modal) => {
          modal.present();
        })
        return;
      }else if(val.needsEmailValidation){
        this.modalCtrl.create({component: EmailValidationPage}).then((modal) => {
          modal.present();
        })

        return;
      }
      this.userData = val;
    });

    this.haveMatches = this.matchService.souls.length > 0;
  }

    async chat(soulToChat : any){
      this.matchService.markAsRead(soulToChat);
      let modal = this.modalCtrl.create({component: ChatPage, componentProps: {me: this.userData, otherSoul : soulToChat,},  backdropDismiss: true });
      
      (await modal).onDidDismiss().then((val) => {
        this.refreshListEvent.emit(); // Emit event when matches are loaded
        console.log('Data returned from chat modal: ' + JSON.stringify(val.data));
        if (val && val.data === "logout") {
          this.router.navigateByUrl('/login');
          return;
        }
  
        if (val && val.data === "shouldRefreshList") {
          this.matchService.loadMatches(false);
        }
      });
  
      (await modal).present();
    }

}
